export const Constants = {
    graphql_public: {
        Enums: {},
    },
    public: {
        Enums: {
            course_status: ["draft", "published", "archived"],
            direction: ["long", "short"],
            duration: ["intraday", "multiday"],
            fcm_delivery_status: ["pending", "sent", "failed", "skipped"],
            go_read_topic: ["finance", "reset", "health"],
            go_watch_topic: ["finance", "reset", "health"],
            lesson_type: ["video", "text", "quiz"],
            market: ["crypto", "equities", "forex", "commodity"],
            pattern_specification: [
                "extremely-high-slung",
                "high-slung",
                "broadly-symmetrical-high-side",
                "perfectly-symmetrical",
                "broadly-symmetrical-low-side",
                "low-slung",
                "extremely-low-slung",
            ],
            phq_status: ["pending", "confirmed", "rejected"],
            progress_status: ["not_started", "in_progress", "completed"],
            question_type: ["video", "image", "text"],
            role: [
                "commander",
                "admin",
                "captain",
                "full_lieutenant",
                "second_lieutenant",
                "staff_sergeant",
                "sergeant",
                "corporal",
                "lance_corporal",
                "rifleman",
                "recruit",
            ],
            setup_status: ["published", "archived", "draft"],
            stage: [
                "unspecified",
                "funneling",
                "triggered",
                "first_interim",
                "second_chance",
                "second_interim",
                "target",
                "overperformance",
                "overperformance-closed",
                "stopped-out",
                "timed-out",
                "spoiled",
                "failed",
            ],
            subscription_plan: [
                "full-monthly",
                "crypto-monthly",
                "equities-monthly",
                "full-yearly",
                "crypto-yearly",
                "equities-yearly",
            ],
            subscription_status: [
                "active",
                "trialing",
                "past-due",
                "cancelled",
                "pending-cancel",
                "expired",
                "on-hold",
                "switched",
                "pending",
            ],
            user_status: ["applicant", "approved", "active", "cancelled"],
            video_providers: ["vimeo", "youtube", "dailymotion"],
        },
    },
};
//# sourceMappingURL=api.js.map